import gql from "graphql-tag";

// Selects the same fields as CURRENT_AUTOMATION_STATUS_QUERY so the payload can
// be written straight into that query's cache entry (see InstrumentsPanel.jsx).
export default gql`
  subscription {
    subscribeToAutomationStatus {
      id
      description
      status
      autoGenerated
      insertedAt
      url
    }
  }
`;
